import {
  CURRENT_USER_PERMISSION,
  LOADING,
  USER_PERMISSION,
  USERS,
} from "../actionType/userManagementType";

const initialState = {
  loading: true,
  users: [],
  activeUserCount: 0,
  userPermissions: [],
  currentUserPermissions: null,
};

const UserManagementReducer = (state = initialState, action) => {
  const { type, payload, count } = action;
  switch (type) {
    case LOADING:
      return { ...state, loading: payload };
    case USERS:
      return { ...state, users: payload, activeUserCount: count };
    case USER_PERMISSION:
      return { ...state, userPermissions: payload };
    case CURRENT_USER_PERMISSION:
      return { ...state, currentUserPermissions: payload };
    default:
      return state;
  }
};

export default UserManagementReducer;
